module.exports = __webpack_public_path__ + "img/811-0062e2.png";